var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1341_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51563 21.1865C3.12698 21.1865 2.8125 20.872 2.8125 20.4833C2.8125 16.0009 6.06328 12.1631 10.4777 11.4222C10.8588 11.3494 11.2227 11.6158 11.2873 11.9996C11.3511 12.3821 11.0929 12.7446 10.7098 12.8092C6.9758 13.4354 4.21875 16.6903 4.21875 20.4833C4.21875 20.872 3.90427 21.1865 3.51563 21.1865Z",
    fill: "#4DA6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4056 12.5864C13.0685 12.5864 12.7705 12.3433 12.7128 11.9993C12.649 11.6169 12.9072 11.2543 13.2903 11.1898C17.0243 10.5635 19.7813 7.30866 19.7813 3.51562C19.7813 3.12698 20.0958 2.8125 20.4845 2.8125C20.8731 2.8125 21.1876 3.12698 21.1876 3.51562C21.1876 7.99805 17.9368 11.8359 13.5224 12.5768C13.4833 12.583 13.4441 12.5864 13.4056 12.5864Z",
    fill: "#4596E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 12.7031H3.51562C3.12698 12.7031 2.8125 12.3886 2.8125 12C2.8125 11.6114 3.12698 11.2969 3.51562 11.2969H10.5938C10.9824 11.2969 11.2969 11.6114 11.2969 12C11.2969 12.3886 10.9824 12.7031 10.5938 12.7031Z",
    fill: "#4DA6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4844 12.7031H13.4062C13.0176 12.7031 12.7031 12.3886 12.7031 12C12.7031 11.6114 13.0176 11.2969 13.4062 11.2969H20.4844C20.873 11.2969 21.1875 11.6114 21.1875 12C21.1875 12.3886 20.873 12.7031 20.4844 12.7031Z",
    fill: "#4596E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4063 9.89062H10.5938C10.2051 9.89062 9.89062 10.2051 9.89062 10.5938V13.4063C9.89062 13.7949 10.2051 14.1094 10.5938 14.1094H13.4063C13.7949 14.1094 14.1094 13.7949 14.1094 13.4063V10.5938C14.1094 10.2051 13.7949 9.89062 13.4063 9.89062ZM12.7031 12.7031H11.2969V11.2969H12.7031V12.7031Z",
    fill: "#5AF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 9.89062H12V11.2969H12.7031V12.7031H12V14.1094H13.4062C13.7949 14.1094 14.1094 13.7949 14.1094 13.4062V10.5938C14.1094 10.2051 13.7949 9.89062 13.4062 9.89062Z",
    fill: "#51DAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92188 19.7812H2.10938C1.72073 19.7812 1.40625 20.0957 1.40625 20.4844V23.2969C1.40625 23.6855 1.72073 24 2.10938 24H4.92188C5.31052 24 5.625 23.6855 5.625 23.2969V20.4844C5.625 20.0957 5.31052 19.7812 4.92188 19.7812ZM4.21875 22.5938H2.8125V21.1875H4.21875V22.5938Z",
    fill: "#4D69AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 0H19.0781C18.6895 0 18.375 0.314484 18.375 0.703125V3.51562C18.375 3.90427 18.6895 4.21875 19.0781 4.21875H21.8906C22.2793 4.21875 22.5938 3.90427 22.5938 3.51562V0.703125C22.5938 0.314484 22.2793 0 21.8906 0ZM21.1875 2.8125H19.7812V1.40625H21.1875V2.8125Z",
    fill: "#4D69AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 14.1094C0.946219 14.1094 0 13.1632 0 12C0 10.8368 0.946219 9.89062 2.10938 9.89062C3.27253 9.89062 4.21875 10.8368 4.21875 12C4.21875 13.1632 3.27253 14.1094 2.10938 14.1094Z",
    fill: "#4D69AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 14.1094C20.7275 14.1094 19.7812 13.1632 19.7812 12C19.7812 10.8368 20.7275 9.89062 21.8906 9.89062C23.0538 9.89062 24 10.8368 24 12C24 13.1632 23.0538 14.1094 21.8906 14.1094Z",
    fill: "#4D69AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1341_1003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon);
export default __webpack_public_path__ + "static/media/flow_icon.3edb0f24e65952c99e7ff9eee9685e03.svg";
export { ForwardRef as ReactComponent };